// extracted by mini-css-extract-plugin
module.exports = {"b1qum04j":"b1qum04j"};